import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useUpdateAccommodationsConsoleSearchParams } from './useUpdateAccommodationsConsoleSearchParams';
import { QUERY_PARAM_KEYS, SORT_QUERY_PARAM_KEY } from './constants';
import { formatRoomOccupancyToString } from '@shared/utils/joyHotelUrl';
import { SortOption } from '@apps/accommodations/AccommodationsConsole.types';

export const useApplyUserInitiatedSearchParamsToUrl = () => {
  const { applyAccommodationConsoleSearchParamsToUrl } = useUpdateAccommodationsConsoleSearchParams();

  const applyUserInitiatedSearchParamsToUrl = useEventCallback(
    (args: {
      pickedByCouple?: boolean | null;
      dates?: {
        checkin: string;
        checkout: string;
      };
      map?: { destination?: string | null; lat: number; lng: number; radius?: number; googlePlaceId?: string };
      rooms?: Array<{ adults: number; childrenAges: number[] }>;
      sort?: SortOption;
      actionType: 'replace' | 'push';
    }) => {
      const searchParams: Record<string, string | null> = {};

      // Update dates
      if (args.dates) {
        searchParams[QUERY_PARAM_KEYS.checkin] = args.dates.checkin;
        searchParams[QUERY_PARAM_KEYS.checkout] = args.dates.checkout;
      }

      // Update map location
      if (args.map) {
        searchParams[QUERY_PARAM_KEYS.destination] = args.map.destination ?? null;
        searchParams[QUERY_PARAM_KEYS.lat] = args.map.lat.toString();
        searchParams[QUERY_PARAM_KEYS.lng] = args.map.lng.toString();
        typeof args.map.radius === 'number' && (searchParams[QUERY_PARAM_KEYS.radius] = args.map.radius.toString());
        args.map.googlePlaceId && (searchParams[QUERY_PARAM_KEYS.googlePlaceId] = args.map.googlePlaceId);
      }

      // Update rooms
      if (args.rooms) {
        // updateQueryParams(QUERY_PARAM_KEYS.rooms, args.rooms.map(_roomToQueryString).join(','));
        searchParams[QUERY_PARAM_KEYS.rooms] = args.rooms.map(formatRoomOccupancyToString).join(',');
      }

      // Update sort
      if (args.sort) {
        searchParams[SORT_QUERY_PARAM_KEY] = args.sort;
      }

      applyAccommodationConsoleSearchParamsToUrl({ searchParams, actionType: args.actionType });
    },
    [applyAccommodationConsoleSearchParamsToUrl],
  );

  return {
    applyUserInitiatedSearchParamsToUrl,
  };
};
